import React from "react";
import styled from "styled-components";

export default function BusinessBodyCard(props) {
  return (
    <BusinessCardWrapper>
      <div className="BusinessCard" style={{ color: props.color }}>
        <img src={props.image} alt="icon" />
        <h4>{props.text}</h4>
      </div>
    </BusinessCardWrapper>
  );
}

export const BusinessCardWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .BusinessCard {
    display: flex;
    background: rgba(255, 255, 255, 0.3);
    mix-blend-mode: normal;
    border: 3px dashed;
    box-shadow: 0px 5px 4px rgba(0, 0, 0, 0.15);
    border-radius: 40px;
    justify-content: space-evenly;
    align-items: center;
    transition: all 0.5s ease;
    width: 100%;
    max-width: 500px;
    height: 130px;
    padding: 0 20px;

    :hover {
      cursor: pointer;
      transform: scale(1.05);
      box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.2);
    }

    @media (min-width: 1600px) {
      height: 140px;
      max-width: 550px;
      padding: 0 25px;
    }

    @media (max-width: 1599px) and (min-width: 1400px) {
      height: 135px;
      max-width: 520px;
      padding: 0 22px;
    }

    @media (max-width: 1399px) and (min-width: 1200px) {
      height: 130px;
      max-width: 500px;
      padding: 0 20px;
    }

    @media (max-width: 1199px) and (min-width: 900px) {
      height: 125px;
      max-width: 480px;
      padding: 0 18px;
    }

    @media (max-width: 899px) and (min-width: 768px) {
      height: 120px;
      max-width: 450px;
      padding: 0 16px;
    }

    @media (max-width: 767px) and (min-width: 600px) {
      height: 115px;
      max-width: 420px;
      padding: 0 15px;
    }

    @media (max-width: 599px) and (min-width: 480px) {
      height: 110px;
      max-width: 400px;
      padding: 0 12px;
      margin: 10px auto;
    }

    @media (max-width: 479px) and (min-width: 375px) {
      height: 105px;
      max-width: 380px;
      padding: 0 10px;
      margin: 8px auto;
    }

    @media (max-width: 374px) {
      height: 100px;
      max-width: 350px;
      padding: 0 8px;
      margin: 5px auto;
    }
  }

  .BusinessCard img {
    width: 75px;
    height: 75px;
    padding: 10px;
    object-fit: contain;
    flex-shrink: 0;

    /* Extra large desktop screens */
    @media (min-width: 1600px) {
      width: 80px;
      height: 80px;
      padding: 12px;
    }

    /* Large desktop screens */
    @media (max-width: 1599px) and (min-width: 1400px) {
      width: 75px;
      height: 75px;
      padding: 10px;
    }

    /* Medium desktop screens */
    @media (max-width: 1399px) and (min-width: 1200px) {
      width: 70px;
      height: 70px;
      padding: 8px;
    }

    /* Small desktop and large tablet */
    @media (max-width: 1199px) and (min-width: 900px) {
      width: 65px;
      height: 65px;
      padding: 8px;
    }

    /* Tablet landscape */
    @media (max-width: 899px) and (min-width: 768px) {
      width: 60px;
      height: 60px;
      padding: 6px;
    }

    /* Tablet portrait */
    @media (max-width: 767px) and (min-width: 600px) {
      width: 55px;
      height: 55px;
      padding: 6px;
    }

    /* Large mobile */
    @media (max-width: 599px) and (min-width: 480px) {
      width: 50px;
      height: 50px;
      padding: 5px;
    }

    /* Medium mobile */
    @media (max-width: 479px) and (min-width: 375px) {
      width: 45px;
      height: 45px;
      padding: 4px;
    }

    /* Small mobile */
    @media (max-width: 374px) {
      width: 40px;
      height: 40px;
      padding: 3px;
    }
  }

  .BusinessCard h4 {
    font-size: 23px;
    line-height: 1.2;
    letter-spacing: -0.011em;
    word-spacing: 0.15em;
    padding: 10px;
    margin: 0;
    flex: 1;
    text-align: center;
    overflow-wrap: break-word;
    word-wrap: break-word;
    hyphens: auto;

    @media (min-width: 1600px) {
      font-size: 25px;
      line-height: 1.3;
    }

    @media (max-width: 1599px) and (min-width: 1400px) {
      font-size: 23px;
      line-height: 1.2;
    }

    @media (max-width: 1399px) and (min-width: 1200px) {
      font-size: 21px;
    }

    @media (max-width: 1199px) and (min-width: 900px) {
      font-size: 19px;
    }

    @media (max-width: 899px) and (min-width: 768px) {
      font-size: 18px;
      padding: 8px;
    }

    @media (max-width: 767px) and (min-width: 600px) {
      font-size: 17px;
      padding: 6px;
    }

    @media (max-width: 599px) and (min-width: 480px) {
      font-size: 16px;
      padding: 5px;
    }

    @media (max-width: 479px) and (min-width: 375px) {
      font-size: 15px;
      padding: 4px;
    }
    @media (max-width: 374px) {
      font-size: 14px;
      padding: 3px;
    }
  }
`;
